/** @jsxImportSource theme-ui */

import { useBreakpointIndex } from '@theme-ui/match-media';
import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import * as dto from 'client/dto';
import { isMobile } from 'utils/responsive';

import { ViewPanel } from 'components/_controls/ViewPanel';
import DashboardToolbar from 'components/Navigationbar/DashboardToolbar';
import { IPanelProps } from 'components/Panel';

import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';

import DiseaseActivityEventListItem from './DiseaseActivityEventListItem';
import DiseaseActivityListToolbar from './DiseaseActivityListToolbar';

export type DiseaseActivityByCountryListPanelProps = IPanelProps & {
  isStandAlone?: boolean;
  events: dto.GetEventModel[];
  isLoading?: boolean;
  onEventSelected?: (event: dto.GetEventModel) => void;
};

const DiseaseActivityEventListPanel: React.FC<DiseaseActivityByCountryListPanelProps> = ({
  isStandAlone = true,
  //   activePanel,
  events,
  isLoading = false,
  onClose = undefined,
  onMinimize = undefined,
  isMinimized = false,
}) => {
  const isMobileDevice = isMobile(useBreakpointIndex());

  const disacParams = useSelector(diseaseActivityPanelsSelectors.disacParams);

  // todo: FIX THIS LOGIC
  // if (
  //   isMobileDevice &&
  //   activePanel !== 'EventListPanel' &&
  //   activePanel !== 'DiseaseEventListPanel'
  // ) {
  //   return null;
  // }

  return (
    <ViewPanel
      title="All Activity"
      isAnimated
      canMinimize
      isLoading={isLoading}
      onClose={onClose}
      isMinimized={isMinimized}
      onMinimize={onMinimize}
      isStandAlone={isStandAlone}
      canClose={!isStandAlone}
      toolbar={
        <>
          {isMobileDevice && isStandAlone && <DashboardToolbar showToolbar />}
          <DiseaseActivityListToolbar />
        </>
      }
    >
      <List>
        {events.map(e => (
          <DiseaseActivityEventListItem
            key={`${e.eventInformation.diseaseActivityKey.diseaseId}-${e.eventInformation.diseaseActivityKey.speciesId}-${e.eventInformation.diseaseActivityKey.countryId}`}
            isActive={
              !!disacParams &&
              e.eventInformation.diseaseActivityKey.countryId === disacParams.countryId &&
              e.eventInformation.diseaseActivityKey.diseaseId === disacParams.diseaseId &&
              e.eventInformation.diseaseActivityKey.speciesId === disacParams.speciesId
            }
            model={e}
            isStandAlone={isStandAlone}
          />
        ))}
      </List>
    </ViewPanel>
  );
};

export default DiseaseActivityEventListPanel;
